import classNames from 'classnames';

import styles from './_index.module.scss';

const Spinner = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    // additional `div` applies padding to Spinner similar to svg's
    <div className={classNames(styles['spinner'], className)} {...props}>
      <div />
    </div>
  );
};

export default Spinner;
